import React from "react";
import type { LucideIcon } from "lucide-react";
import { Button } from "./Button";

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ icon: Icon, title, description, action, className = "" }) => (
  <div className={`flex flex-col items-center justify-center text-center py-12 px-6 ${className}`}>
    {Icon && (
      <div className="h-12 w-12 rounded-xl bg-brand-100 flex items-center justify-center mb-4 animate-[bounce_3s_ease-in-out_infinite]">
        <Icon className="h-6 w-6 text-brand-600" />
      </div>
    )}
    <p className="text-sm font-semibold text-ink-900 font-sora mb-1">{title}</p>
    {description && <p className="text-xs text-ink-500 font-sans max-w-sm mb-4">{description}</p>}
    {action && (
      <Button size="sm" onClick={action.onClick}>
        {action.label}
      </Button>
    )}
  </div>
);

export default EmptyState;
